import { atom } from 'recoil';
import { Units } from '../types';
import { getDefaultUnitsValue } from '../utils/getDefaultUnitsValue';

export const unitsState = atom<Units>({
  key: 'units',
  default: getDefaultUnitsValue()
});
